import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { CommonService } from '@service/common.service';

@Component({
  selector: 'app-expired',
  templateUrl: './expired.component.html',
  styleUrls: ['./expired.component.scss']
})
export class ExpiredComponent implements OnInit {

  constructor(public menu: MenuServiceInt, private router: Router, private app: AppComponent,private commonService: CommonService) {
    this.menu.display = false;
    this.app.languageIsLoaded = false;
  }

  ngOnInit() {
    this.commonService.clearMessage();
  }

  onSubmit() {
    this.router.navigate(["login"]);
  }

}
